export enum TransactionType {
    CheckOut = 0,
    CheckIn = 1,
    Crosscheck = 2,
    ConnectedTransactionCheckOut = 3,
    ConnectedTransactionCheckIn = 4,
    ShiftCrosscheck = 5,
    Disposed = 6,
    ConnectedTransactionDepositToAmbulanceBag = 7,
    ConnectedTransactionDispose = 8,
    OperatingRoomTransfer = 9,
    OperatingRoomReturn = 10,
    ConsumptionInOperatingRoom = 11,

    // This is not a transaction type the server will accept. It is for the signing page to know witch api to send to.
    AmbulanceTransaction = 100,
}
export enum TransactionOverview {
    // Overview (Form display)
    formOverview = 1,
    successOverview = 2,
    doubleSignOverview = 3,
}
